<section class="toast-region" aria-live="polite" aria-label="הודעות מערכת">
  <article
    class="app-toast app-toast--{{ toast.type }}"
    *ngFor="let toast of toasts$ | async; trackBy: trackToast"
    role="status">
    <span class="app-toast__accent" aria-hidden="true"></span>
    <span class="app-toast__icon" aria-hidden="true">
      <span *ngIf="toast.type === 'success'">✓</span>
      <i *ngIf="toast.type !== 'success'" class="mdi {{ icon(toast.type) }}"></i>
    </span>
    <span class="app-toast__content">
      <strong>{{ toast.title }}</strong>
      <small *ngIf="toast.message">{{ toast.message }}</small>
    </span>
    <button type="button" class="app-toast__close" (click)="dismiss(toast.id)" aria-label="סגירת ההודעה">
      <span aria-hidden="true">×</span>
    </button>
  </article>
</section>
